module.exports = (selector = '') => {
    if (global.document && global.document.querySelectorAll) {
        return (global.document.querySelectorAll(selector).length > 0);
    }
    return true;
};



// WEBPACK FOOTER //
// ./app/lib/ui/isElementInDOM.js